import { Button } from "@/components/ui/button";
import { PhoneCall } from "lucide-react";
import { usePhoneBar } from "@/contexts/PhoneBarContext";
import safewayLogoWhite from "@/assets/safeway-logo-white.png";
import heroImg from "@/assets/hero-roofing.jpg";

export const AdsFreeInspectionCTA = () => {
  const { phoneNumber } = usePhoneBar();
  const formattedPhone = phoneNumber.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return (
    <section className="relative py-20 overflow-hidden">
      <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" />
      <div className="absolute inset-0 bg-primary/85" />
      <div className="relative container mx-auto px-4 text-center text-primary-foreground">
        <img src={safewayLogoWhite} alt="Safeway Roofing" className="h-16 w-auto mx-auto mb-6" />
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4">
          Get A Free Roofing Inspection
        </h2>
        <p className="text-lg opacity-90 mb-8 max-w-xl mx-auto">
          Our certified inspectors use drone technology to assess your roof — at no cost or commitment to you.
        </p>
        <Button
          size="lg"
          variant="secondary"
          className="font-bold text-base px-8"
          onClick={() => (window.location.href = `tel:${phoneNumber}`)}
        >
          <PhoneCall className="w-5 h-5 mr-2" />
          Schedule Now — {formattedPhone}
        </Button>
      </div>
    </section>
  );
};
